<template>
  <div class="order-container">
    <el-tabs v-model="activeTab" type="card" class="order-tab-container">
      <el-tab-pane label="签约信息" name="1">
        <el-empty v-if="!orderDetail.orderCompact" description="暂无数据"/>
        <order-compact v-else :order-compact="orderDetail.orderCompact"/>
      </el-tab-pane>
      <el-tab-pane label="预审单" name="2">
        <el-empty v-if="!orderDetail.orderReady" description="暂无数据"/>
        <order-ready v-else :order-ready="orderDetail.orderReady"/>
      </el-tab-pane>
      <el-tab-pane label="影像资料" name="3">
        <order-tab-content>
          <el-empty v-if="!orderDetail.compactMaterialList" description="暂无数据"/>
          <order-material v-else :materials="orderDetail.compactMaterialList" :model="2"/>
        </order-tab-content>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {hasPer} from "@/utils/common";
import OrderCompact from "@/views/order/info/componet/orderCompact.vue";
import OrderReady from "@/views/order/info/componet/orderReady.vue";
import OrderMaterial from "@/views/order/info/componet/OrderMaterial.vue";
import OrderTabContent from "@/views/order/info/tab/orderTabContent.vue";

export default {
  name: "SignTab",
  components: {
    OrderTabContent,
    OrderMaterial,
    OrderReady,
    OrderCompact
  },
  props: {
    orderDetail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeTab: '1'
    };
  },
  computed: {
    order() {
      return this.orderDetail.order;
    }
  },
  mounted() {
  },
  created() {
  },
  methods: {
    hasPer
  }
};
</script>

<style scoped>
</style>

